import { Link } from "react-router-dom";
import { FaHeartbeat } from "react-icons/fa";

function AuthLayout({ children, title, description }) {
  return (
    <div className="auth-layout">
      <section className="auth-brand-panel">
        <Link className="auth-logo" to="/">
          <div className="logo-symbol">
            <FaHeartbeat />
          </div>

          <div className="brand-text">
            <strong>ZETH</strong>
            <span>HEALTH</span>
            <small>STAFFING INC.</small>
          </div>
        </Link>

        <div className="auth-brand-content">
          <p className="account-label">Zeth Health Staffing</p>

          <h1>{title}</h1>

          <p>{description}</p>

          <ul className="auth-benefits">
            <li>Verified healthcare professionals</li>
            <li>Flexible assignments across Canada</li>
            <li>Responsive staffing support</li>
          </ul>
        </div>
      </section>

      <section className="auth-form-panel">
        <div className="auth-form-wrapper">{children}</div>
      </section>
    </div>
  );
}

export default AuthLayout;